import React, { useState, useEffect } from "react";
import { getData } from "../../services/api.service";
import { toastError } from "../common/Toast";
import {
  FaUsersCog,
  FaInfoCircle
} from "react-icons/fa";

function RolesManager() {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadRoles();
  }, []);

  const loadRoles = async () => {
    try {
      setLoading(true);
      const response = await getData('/api/admin/get_roles');
      setRoles(response.data.roles || []);
    } catch (error) {
      console.error('Error cargando roles:', error);
      toastError('Error al cargar los roles');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="roles-manager">
      <div className="card">
        <div className="card-header">
          <h5 className="card-title mb-0">
            <FaUsersCog className="me-2 text-primary" />
            Visualización de Roles de Usuario
          </h5>
          <div className="alert alert-info mt-3 mb-0" role="alert">
            <FaInfoCircle className="me-2" />
            Vista de solo lectura. Los roles están predefinidos en el sistema y sus permisos se gestionan a nivel de base de datos.
          </div>
        </div>

        <div className="card-body">
          {loading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
              <div className="mt-2 text-muted">Cargando roles...</div>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Descripción del Rol</th>
                    <th>Estado</th>
                    <th>Fecha Creación</th>
                  </tr>
                </thead>
                <tbody>
                  {roles.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="text-center text-muted py-4">
                        No hay roles registrados
                      </td>
                    </tr>
                  ) : (
                    roles.map(role => (
                      <tr key={role.id}>
                        <td>#{role.id}</td>
                        <td>
                          <strong className="text-capitalize">{role.role_description}</strong>
                        </td>
                        <td>
                          <span className={`badge ${role.active ? 'bg-success' : 'bg-danger'}`}>
                            {role.active ? 'Activo' : 'Inactivo'}
                          </span>
                        </td>
                        <td>
                          <small className="text-muted">
                            {role.inserted_date ? new Date(role.inserted_date).toLocaleDateString('es-AR') : 'N/A'}
                          </small>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default RolesManager;
